import { action } from 'typesafe-actions';

import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';
import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { IPmListFilterParams } from '../interfaces/IPmListFilterParams';
import { PreventionActionsEnum } from '../enums/PreventionActionsEnum';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';

export const preventionGetKnms = () => action(PreventionActionsEnum.PREVENTION_GET_KNMS);
export const preventionGetKnmsNextPage = () => action(PreventionActionsEnum.PREVENTION_GET_KNMS_NEXT_PAGE);
export const preventionSetOrder = (value: string) => action(PreventionActionsEnum.PREVENTION_SET_ORDER, { value });
export const preventionSetData = (
  data: IKnmRaw[],
  page: number,
  pageCount: number,
  totalCount: number,
  rejected: number,
) => action(PreventionActionsEnum.PREVENTION_SET_DATA, { data, page, pageCount, totalCount, rejected });
export const preventionSetSearchValue = (value: string) =>
  action(PreventionActionsEnum.PREVENTION_SET_SEARCH_VALUE, { value });
export const preventionDeleteKnms = (ids: number[]) => action(PreventionActionsEnum.PREVENTION_DELETE_KNMS, { ids });
export const preventionListExportPreventions = (
  notify: ({ id }: IExport) => void,
  format: ExportFormatsEnum,
  columns: ITableColumn<IKnmRaw>[],
  filter?: IPmListFilterParams,
) => action(PreventionActionsEnum.PREVENTION_LIST_EXPORT_PREVENTIONS, { format, columns, filter, notify });
export const preventionGetPmSelectOptions = (searchValue: string, callback: (options: ISelectOption[]) => void) =>
  action(PreventionActionsEnum.PREVENTION_GET_PM_SELECT_OPTIONS, { searchValue, callback });
